<mat-dialog-content>
  <div>
    <div class="monitor-gray">
      <mat-card-content class="monitor-picture">
        <img *ngIf="monitor.PictureURL" class="monitorImage" [imageSrc]="monitor.PictureURL" />
      </mat-card-content>
    </div>

    <mat-progress-bar *ngIf="monitor.ScreenState && monitor.ScreenState.ScreenContentMode == contentModes.Playlist"
      class="greenline-progress" [matTooltip]="monitor.ScreenState.AppTimeLeft" mode="determinate" [value]="monitor.ScreenState.AppPercentProgress"
      max="100"></mat-progress-bar>

    <div class="info" *ngIf="monitor.ScreenState && monitor.ScreenState.ScreenContentMode == contentModes.Playlist; else editIcon">
      <div class="info__header d-flex justify-content-between">
        <span class="title mr-1 mb-1">{{schedule.Playlist.PlaylistTitle}}</span>
        <ng-container *ngTemplateOutlet="editIcon"></ng-container>
      </div>
      <span class="subtitle">{{subtitle}}</span>
    </div>
    <hr>

    <ng-template #editIcon>
      <div
        class="edit-button d-inline-flex justify-content-end"
        [ngClass]="{'only-icon': !monitor.ScreenState || monitor.ScreenState.ScreenContentMode !== contentModes.Playlist}"
      >
        <mat-icon class="action-button timeline-edit-icon" svgIcon="edit" matTooltip="Edit item" (click)="onEdit()"></mat-icon>
      </div>
    </ng-template>

    <div class="actions-list">
      <button [disabled]="!(monitor.AssignedPlaylist && monitor.Status == screenStatuses.Waiting)" (click)="monitor.playAssigned()">
        <mat-icon svgIcon="play_arrow" matTooltip="Play"></mat-icon>
        <span> Play </span>
      </button>
      <button [disabled]="monitor.Status != screenStatuses.Playing" (click)="monitor.stopPlaylist()">
        <mat-icon svgIcon="stop" matTooltip="Stop"></mat-icon>
        <span> Stop</span>
      </button>
      <button [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode != contentModes.SingleApp)"
        (click)="monitor.playNext()">
        <mat-icon svgIcon="fast_forward" matTooltip="Next"></mat-icon>
        <span> Next</span>
      </button>
      <button [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode != contentModes.SingleApp)"
        (click)="monitor.playPrevious()">
        <mat-icon svgIcon="fast_rewind" matTooltip="Previous"></mat-icon>
        <span> Previous</span>
      </button>
      <button [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode == contentModes.SingleApp)"
        (click)="monitor.refreshPlaylist()">
        <mat-icon svgIcon="refresh" matTooltip="Refresh"></mat-icon>
        <span> Refresh</span>
      </button>
    </div>
  </div>
</mat-dialog-content>
